import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { tvdData, TvdMetricData, eroiIds } from '../../types/tvd-types';
import { eroiService } from '../../services/eroi-metric.service';
import { Subscription } from 'rxjs';
import { TVDService } from '../../services/tvd.service';
import { FiltersService } from 'src/app/core/services/filters.service';
import { UomOption } from 'src/app/core/services/currency-uom.service';

@Component({
    selector: 'tvd-metric-summary',
    templateUrl: './tvd-metric-summary.component.html',
    styleUrls: ['./tvd-metric-summary.component.scss'],
    standalone: false
})
export class TvdMetricSummaryComponent implements OnInit, OnChanges {
  @Input() metricId: string = "title";
  @Input() data: tvdData[] | TvdMetricData[] = [];
  @Input() selectedProgram: string = "";
  @Input() measurementSystem: UomOption = 'Imperial';

  private isTvdInitialLoadCompletedSubscription: Subscription | undefined;
  isTvdLoadComplete: boolean = false;

  valueContribution: number | undefined = 0;

  constructor(
    private _eroiService: eroiService,
    private _tvdService: TVDService,
    private _filtersService: FiltersService
  ) {}

  ngOnInit(): void {
    this.isTvdInitialLoadCompletedSubscription = this._tvdService.tvdInitialLoadCompleteObservable.subscribe(f => {
      this.isTvdLoadComplete = f;
    });

    // Get the total value contribution for the items in tvdData
    this.valueContribution = this.calculateValueContribution(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedProgram']) {
      this.valueContribution = this.calculateValueContribution(this.data);
    }

    if (changes['data']) {
      this.valueContribution = this.calculateValueContribution(this.data);
    }
  }

  private calculateValueContribution(data: tvdData[] | TvdMetricData[]): number {
    return (data as Array<tvdData | TvdMetricData>).reduce((acc: number, item: tvdData | TvdMetricData) => {
      return acc + (Number(item.valueContribution?.replace(/,/g, '') ?? '') || 0);
    }, 0);
  }
}
